export enum ACF_FIELDS {
  LUXURY = 'luxury',
  LUXURY_QUALITY = 'luxury_quality',
  RESORT_STYLE =  'resort style',
  RESORT_OR_CAMP_STYLE = 'resort_or_camp_style',
  ROOM_TYPE = 'room type',
  PRICE_RANGE = 'price range',
  TRIP = 'trip',
  LENGTH_OF_TRIP = 'length_of_trip'
}